import React, { useEffect, useState } from "react";
import _ from "lodash";

import { parseJwt } from "../utils/utils";

function WithAuth({ history, match, children, test }) {
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      let decodedAuthToken = parseJwt(token);

      if (!decodedAuthToken.terminosAceptados) {
        history.push("/logout");
      }
    } else {
      history.push("/logout");
    }
  }, []);

  return children({
    history: history,
    match: match,
    test: test,
  });
}

export default WithAuth;
